import React from 'react';
import { DoctoralEnuSourcesData } from '../types';
import { OFFICIAL } from '../doctoralTemplate';
import { Card, Hero, SourceCard } from './dp120Parts';

interface DoctoralSourcesViewProps {
  data?: DoctoralEnuSourcesData | null;
}

const FIXED: [string, string, string, [string, string][], string][] = [
  ['Докторантура ENU', 'Общая официальная информация для докторантов.', 'Докторантура ENU', [['Открыть страницу', OFFICIAL.phd]], 'span4'],
  ['Практики и Smart.ENU', 'Официальная информация и электронная система практики.', 'Практика', [['Практика ENU', OFFICIAL.practice], ['Smart.ENU', OFFICIAL.smart]], 'span4'],
  ['Стажировка', 'Официальный маршрут научной стажировки.', 'Научная стажировка', [['Стажировка ENU', OFFICIAL.internship]], 'span4'],
  ['Предзащита и защита', 'Диссертационный совет и нормативные документы.', 'Защита', [['Диссертационный совет', OFFICIAL.defense], ['Нормативные документы ENU', OFFICIAL.regulations], ['Правила присуждения степеней', OFFICIAL.degree]], 'span6'],
  ['Трудоустройство и отработка', 'Актуальная редакция, а не только памятка прошлых лет.', 'Правила №403', [['Правила №403', OFFICIAL.employmentRules], ['Закон «Об образовании»', OFFICIAL.educationLaw]], 'span6'],
];

export const DoctoralSourcesView: React.FC<DoctoralSourcesViewProps> = ({ data }) => (
  <>
    <Hero
      kicker="OFFICIAL ENU / REGULATIONS"
      title="Официальные источники ENU"
      text="Справочный раздел учебного процесса. Перед защитой, практикой, стажировкой или отработкой проверяется актуальная редакция."
    />
    <div className="dp120-grid">
      {FIXED.map(([title, sub, cardTitle, links, span]) => (
        <Card key={title} title={title} sub={sub} span={span}>
          <SourceCard title={cardTitle} text={sub} links={links} />
        </Card>
      ))}
      {(data?.sources || []).map((source) => (
        <Card key={source.title} title={source.title} sub={source.desc} span="span6">
          <SourceCard
            title={source.title}
            text={source.desc}
            links={source.links.map((link) => [link.name, link.url])}
          />
        </Card>
      ))}
    </div>
  </>
);
